<template>
  <v-card flat>
    <v-radio-group v-model="valueComputed" :mandatory="$route.name !== 'qr.qr.id.edit'" row hide-details>
      <v-radio v-for="(item, i) in components" :key="i" :value="item.name" class="ms-8" :label="item.title">
      </v-radio>
    </v-radio-group>
  </v-card>
</template>

<script>
export default {
  name: "catalogTypes",
  props: {
    value: String,
    components: Array,
    frames: []
  },
  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.v-input >>> .v-label {
  margin: 0;
}

.v-input >>> .v-input--selection-controls__input {
  align-self: flex-start;
}
</style>